import { roleIdForOtherRole } from "./TitleHelper";
import { TalentProfileDto } from "~/models/TalentProfileDto";

export const dontNeedEmployments = (v: TalentProfileDto): boolean =>
  v.experience?.noEmploymentsReason !== null;

export const dontNeedTasks = (v: TalentProfileDto): boolean =>
  v.experience?.noEmploymentsReason !== null ||
  v.experience?.employments.every(e => e.roleId === roleIdForOtherRole);
